import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../../common_functions';

const PaperFamilyList = props => {
  const [family, setFamily] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: 90,
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 220,
      sorter: true,
      ellipsis: true,
      ...filter('name'),
    },
    {
      title: 'Note',
      dataIndex: 'note',
      key: 'note',
      width: 350,
      sorter: true,
      ellipsis: true,
      ...filter('note'),
    },
    {
      title: 'Actions',
      key: 'action',
      width: 120,
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/paper-family/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_paper_family?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_paper_family?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'paper_family',
              'Paper Family?',
              family,
              setFamily,
              props?.tabs_permissions?.settings_paper_family?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getPaperFamilyData(pagination);
  })();
  }, []);

  const getPaperFamilyData = async (pagination, filters = {}, sorter = '') => {
    setLoading(true);
    try {
      const response = await props.getItems('paper_family', {
        fields: ['id,name,note'],
        sort: sorter?.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setFamily(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        val && (key == 'id' ? (filtersitems[key] = { _eq: val[0] }) : (filtersitems[key] = { _icontains: val[0] }));
      }
    }
    await getPaperFamilyData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/paper-family" }, { title: "Paper Family" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Paper Family
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_paper_family,
                `/settings/paper-family/new`,
                'Create Paper Family'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              tableLayout="fixed"
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={family}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default PaperFamilyList;
